export default {
  PreviousPolicyNumber: 'رقم الوثيقة السابقة',
  NameOfInsuranceCompany: 'اسم شركة التأمين',
  PreviousInsuranceCompany: 'اسم شركة التأمين  السابقة',
  PreviousPolicyRetroactiveDate: 'تاريخ الأثر الرجعي',
  PreviousPolicyExpirationDate: 'تاريخ انتهاء الوثيقة السابقة',
  RetroactiveDate: 'تاريخ الأثر الرجعي',
  RetroactiveDateDescription: 'التاريخ المذكور في الوثيقة السابقة',
  CheckIfDoNotKnowRetroactiveDate:
    'اختر هنا إذا كنت لا تعرف تاريخ الأثر الرجعي',
  GetQuotes: 'عرض الأسعار',
  UninterruptedDurationAndEffectiveDateMessage:
    'يرجى إدخال مدة الأثر الرجعي المتصلة و/أو تاريخ بدء الوثيقة السابقة',
  UninterruptedRetroactiveDurationPlaceholder:
    'مدة الأثر الرجعي المتصلة (بالأشهر)',
  policyNumberRequired: 'رقم الوثيقة مطلوب',
  insuranceCompanyRequired: 'اسم شركة التأمين مطلوب',
  expirationDateRequired: 'تاريخ انتهاء الصلاحية مطلوب',
  retroactiveDateRequired: 'تاريخ الأثر الرجعي مطلوب',
  previousPolicyDetailsRequired: ' تفاصيل الوثيقة السابقة مطلوبة',
  uninterruptedDurationMax: 'فترة الأثر الرجعي لا يمكن أن تتعدى 240 شهر',
  PolicyEffectiveDatePlaceholder: 'تاريخ بدء الوثيقة',
  dateDifferenceValidation:
    'الفرق بين تاريخ إصدار و تاريخ إنتهاء الوثيقة السابقة لا يمكن أن يكون أقل من سنة ميلادية',
} as const
